import React from 'react';
import './CssLoader.css';

/**
 * Bouncing-ball CSS loader used across the app's loading states.
 * Pure CSS (no JS animation lib) so it stays cheap to render anywhere.
 *
 * `color`/`accent` map to CSS custom properties so callers can recolor
 * without touching the stylesheet.
 */
export default function CssLoader({
  size = 60,
  color,
  accent,
  className = '',
  style = {},
  ...rest
}) {
  const cssVars = {
    ...(color ? { '--ff-loader-color': color } : {}),
    ...(accent ? { '--ff-loader-accent': accent } : {}),
  };

  return (
    <div
      className={`ff-loader ${className}`.trim()}
      style={{ height: size, ...cssVars, ...style }}
      role="status"
      aria-label="Loading"
      {...rest}
    />
  );
}
